import Guid from "@/app/utils/guid"
import NodeEvent from './node-event'
import Node from '@/diagrams/models/node'
import Project from '@/projects/entities/project'

export default class EditNodeEvent extends NodeEvent {

  public node: Node

  constructor(project: Project, node: Node) {
    super(project)
    this.node = node
  }
}
